module.exports = __webpack_public_path__ + "img/gdq_gbt894_2_1986.prt.cc4f4842.jpg";